var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM41.8469 20.3744C42.5333 19.688 43.6463 19.688 44.3327 20.3743C45.0192 21.0608 45.0192 22.1738 44.3327 22.8602L27.5671 39.6257C27.224 39.9688 26.774 40.1405 26.3242 40.1405C25.8745 40.1405 25.4246 39.9689 25.0813 39.6257L15.6673 30.2117C14.9808 29.5252 14.9808 28.4122 15.6673 27.7258C16.3538 27.0394 17.4668 27.0394 18.1532 27.7258L26.3243 35.8969L41.8469 20.3744Z",
    fill: "#B01BAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.1412df7b5d8b435d9cba4dcc77aeb181.svg";
export { ForwardRef as ReactComponent };